import React from 'react';
import '../CSS/TrailEtiquette.css';

export default function TrailEtiquette() {

    return (
        <div className="page">
            <div className="heading">
                <h1 className="headingTitle">Trail Etiquette</h1>
                <h3 style={{fontSize: '30px'}} className="headingTitle">Here are some good rules to follow when on the trail to help others around you have a better experience.</h3>
            </div>
            <ul className="rulesList">
                <li>
                    <h4>Never ride when it's wet (pro tip: use this platform to know if it's wet or not)</h4>
                    <p>Riding in the wet causes ruts and damages the trails. this makes the jobs of trail crew a lot harder.</p>
                </li>
                <li>
                    <h4>When another rider comes up behind find a safe spot to stop and move of to the side.</h4>
                    <p>There's no reason to be hoarding the trail. It's a public space so let others go ahead.</p>
                </li>
                <li>
                    <h4>When you come up behind another rider make sure to let them know politely and give them time to get out of the way.</h4>
                    <p>A good thing to say would be "rider up" or "on your left/right". Having others breathing down your neck isn't a lot of fun so give the other rider time.</p>
                </li>
                <li>
                    <h4>Don't remove rocks from the trails.</h4>
                    <p>I really shouldn't have to say this but there have been some disapearing rocks recently. Rocks are fun obstacles for many riders and by removing them you are taking away part of their fun. If you need easier trails there are plenty if you look around.</p>
                </li>
            </ul>
        </div>
    )
}